export const AJOUTE_SOCIETE = "AJOUTE_SOCIETE";
export const SUPRIMER_SOCIETE = "SUPRIMER_SOCIETE";